import { ChangeEvent } from 'react';
import parse from 'html-react-parser';

import { Checkbox, Flex, Stack, Text, useTheme } from '@chakra-ui/react';

interface CustomCheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  isRenderCheckbox: boolean;
  helperText?: string;
  error?: string;
}

const CheckboxRules = ({
  value,
  onChange,
  label,
  error,
  isRenderCheckbox,
  helperText
}: CustomCheckboxProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepReview: { checkboxRules }
        }
      }
    }
  } = useTheme();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <Stack
      px={{ base: '15px', md: '20px', lg: '25px' }}
      py={{ base: '10px', md: '12px', lg: '12px' }}
      alignItems='flex-start'
      border='2px solid'
      borderRadius='6px'
      gap={{ base: '24px', md: '15px' }}
      background={error ? checkboxRules.errorBackground : 'transparent'}
      borderColor={error ? checkboxRules.errorBorder : 'transparent'}
    >
      {isRenderCheckbox && (
        <Flex gap='30px'>
          <Checkbox
            variant='outline'
            colorScheme='secondary'
            size='xl'
            isChecked={value}
            onChange={handleChange}
            isInvalid={!!error}
          />

          <Text
            fontSize='15px'
            color={checkboxRules.labelColor}
            lineHeight='140%'
          >
            {parse(label ?? '')}
          </Text>
        </Flex>
      )}

      {helperText && (
        <Text
          fontSize='15px'
          color={checkboxRules.textColor}
          lineHeight='140%'
          pl={{ base: 0, md: isRenderCheckbox ? '60px' : 0 }}
        >
          {parse(helperText ?? '')}
        </Text>
      )}
    </Stack>
  );
};

export default CheckboxRules;
